// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2jOnu","footer":"ModalUpdate_footer__2P7YF"};